import { IEnvironment } from './environment-interface';
export const environment: IEnvironment = {
    production: true,
    apiUrl: 'https://api-dev.pc-professional.de',
    streaming: 'https://api-dev.pc-professional.de/streaminghub',
    console_log_level: 'WARNING',
    telemetry_log_level: 'INFO',
    difficult_question_element_base_src:
        'https://questionservice.fahren-lernen.de/api/WebFiles',
    voting_question_element_base_src:
        'https://questionservice.fahren-lernen.de/api/WebFiles/Voting',
    blob_url: 'https://nl9ye2mzk643e7no.blob.core.windows.net',
    app_insights_connection_string: 'InstrumentationKey=29e5e79f-129a-4f5a-b2ee-2df0fc5ae9f2;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    app_insights_cloud_role_name: 'PCP.Client.LiveSessionModerator-dev',
};
